import React from 'react';
import CheckMarkIcon from '../../../../ui/icons/CheckMark/CheckMark';
import ControlView from '../ControlView/ControlView';
import { useTranslations } from '../../../../../hooks/useTranslations';

interface ConfirmPhoneNumberProps {
  featureName?: string;
  isLandscape: boolean;
  narvarProfileUrl: string;
}

const ConfirmPhoneNumber = ({
  featureName,
  isLandscape,
  narvarProfileUrl,
}: ConfirmPhoneNumberProps) => {
  const { notificationCenterSublimeManageYourPreferences } = useTranslations();

  // Temporary translations
  const notificationCenterSublimeConfirmHeading = 'Confirm Your Phone Number';
  const notificationCenterSublimeConfirmText =
    'Reply “Y” to the message sent to the number you provided to complete your opt-in and receive updates on all of your orders.';

  const handlePrimaryButtonClick = () => {
    window.open(`${narvarProfileUrl}/login?type=phone`);
  };

  return (
    <ControlView
      channel="sms"
      isLandscape={isLandscape}
      featureName={featureName}
      icon={<CheckMarkIcon />}
      heading={notificationCenterSublimeConfirmHeading}
      text={notificationCenterSublimeConfirmText}
      primaryButton={{
        text: notificationCenterSublimeManageYourPreferences ?? '',
        onClick: handlePrimaryButtonClick,
      }}
    />
  );
};

export default ConfirmPhoneNumber;
